import React from 'react';
import MobileHome from '../../../components/homepage/MobileHome/MobileHome';
import DesktopHome from '../../../components/homepage/DesktopHome/DesktopHome';
import { useIsMobile } from '../../../hooks/useIsMobile';

const Home = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <MobileHome />;
  } else {
    return <DesktopHome />;
  }
};

export default Home;
